import { render, staticRenderFns } from "./AddCourseToFolder.vue?vue&type=template&id=2131566e&scoped=true&lang=true&"
import script from "./AddCourseToFolder.vue?vue&type=script&lang=js&"
export * from "./AddCourseToFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131566e",
  null
  
)

export default component.exports